import React from 'react';
import { ServiceDetailPage } from '../../components/ServiceLayout/ServiceDetailPage';
import deliveryImg from '../../images/offers-delivery.jpg';

export const LastMilePage = () => (
  <ServiceDetailPage
    meta={{
      title: 'Last-Mile Delivery — Renuit Logistics',
      description: 'Reliable last-mile delivery in the Tampa Bay metro. Residential and commercial, real-time POD, white-label options available.',
      canonical: 'https://www.renuit.pro/services/last-mile-delivery',
    }}
    hero={{
      image: deliveryImg,
      tag: 'Final Leg Execution',
      heading: 'Last-Mile Delivery',
      subheading: 'The last mile is where reputations are built or broken. We help you deliver consistently — from our facility to your customer\'s door.',
    }}
    detail={{
      heading: 'Dependable Delivery, Your Brand or Ours',
      subheading: 'Operating in the Tampa Bay metro, our last-mile service provides scheduled and on-demand delivery routes for businesses that need someone who shows up and delivers, every time.',
      features: [
        'Residential and commercial delivery',
        'Scheduled routes and on-demand dispatching',
        'Proof of delivery (POD) capture — photo + signature',
        'Real-time delivery status notifications',
        'White-label delivery under your brand',
        'Failed delivery management and re-delivery scheduling',
        'Fragile and oversized item handling',
      ],
      image: deliveryImg,
    }}
    steps={[
      { n: '01', title: 'Provide your delivery manifest', body: 'Share your delivery list — addresses, contact info, and any delivery instructions per stop.' },
      { n: '02', title: 'We build the route', body: 'Our team optimizes stop sequence for efficiency and confirms delivery windows with your customers.' },
      { n: '03', title: 'Out for delivery', body: 'Driver departs with real-time GPS tracking active. You and your customers can monitor status.' },
      { n: '04', title: 'POD confirmation', body: 'Photo and signature POD captured at every stop. Delivered to you same day in your preferred format.' },
    ]}
    faq={[
      { q: 'What areas do you cover for last-mile?', a: 'Currently, we serve the greater Tampa Bay metro area including Tampa, St. Petersburg, Clearwater, Bradenton, and Sarasota. Coverage is expanding — ask us about your specific area.' },
      { q: 'What happens if a delivery attempt fails?', a: 'We notify you and the recipient immediately. We schedule a second attempt and track re-delivery separately so nothing falls through the cracks.' },
      { q: 'Can you deliver under our brand name?', a: 'Yes. We offer white-label delivery where your company name and branding appear in all customer communications and tracking links.' },
      { q: 'Do you provide proof of delivery?', a: 'Yes — signature and photo POD are standard on all deliveries. We provide a delivery report within the same business day.' },
    ]}
    cta={{
      heading: 'Ready to Improve Your Last Mile?',
      subheading: 'Tell us your delivery volume and coverage area. We\'ll get back to you within 24h.',
      primaryText: 'Get a Delivery Quote',
      primaryTo: '/quote',
      phone: '(786) 628-3731',
    }}
  />
);
